import { render, staticRenderFns } from "./user-dropdown.vue?vue&type=template&id=202951bd&scoped=true&"
import script from "./user-dropdown.vue?vue&type=script&lang=ts&"
export * from "./user-dropdown.vue?vue&type=script&lang=ts&"
import style0 from "./user-dropdown.vue?vue&type=style&index=0&id=202951bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202951bd",
  null
  
)

export default component.exports